var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2242:1256)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C11.9778 0 13.9112 0.58649 15.5557 1.6853C17.2002 2.78412 18.4819 4.3459 19.2388 6.17317C19.9957 8.00043 20.1937 10.0111 19.8079 11.9509C19.422 13.8907 18.4696 15.6725 17.0711 17.0711C15.6725 18.4696 13.8907 19.422 11.9509 19.8079C10.0111 20.1937 8.00043 19.9957 6.17317 19.2388C4.3459 18.4819 2.78412 17.2002 1.6853 15.5557C0.58649 13.9112 0 11.9778 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0V0ZM3.89 14.78L14.78 3.89C13.4221 2.81327 11.7328 2.24075 10 2.27C8.98377 2.26603 7.97681 2.46327 7.03717 2.85033C6.09753 3.23739 5.24381 3.80663 4.52522 4.52522C3.80663 5.24381 3.23739 6.09753 2.85033 7.03717C2.46327 7.97681 2.26603 8.98377 2.27 10C2.24075 11.7328 2.81327 13.4221 3.89 14.78ZM16.2 5.21L5.2 16.21C6.59813 17.2228 8.27381 17.7814 10 17.81C11.026 17.8113 12.0422 17.6102 12.9903 17.2182C13.9385 16.8262 14.8 16.2509 15.5254 15.5254C16.2509 14.8 16.8262 13.9385 17.2182 12.9903C17.6102 12.0422 17.8113 11.026 17.81 10C17.7764 8.27615 17.2144 6.60417 16.2 5.21Z",
    fill: "#A6A6A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2242:1256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.99,
    height: 19.99,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedIcon);
export default __webpack_public_path__ + "static/media/closed-icon.adfc35d37d3934a72411b63a61a44e5b.svg";
export { ForwardRef as ReactComponent };